import React from "react";
import { FaPaperclip, FaPaperPlane } from "react-icons/fa";

const ChatInputBar = ({
  newMessage,
  onMessageChange,
  onKeyDown,
  onSend,
  file,
  onFileSelect,
  onClearFile,
  fileInputRef,
  chatDisabled,
  remarksMax,
  showCharCount = false,
}) => (
  <div className="border-t border-surface-container p-3 bg-surface-lowest shrink-0">
    {file && (
      <div className="flex items-center justify-between bg-primary-fixed/30 px-3 py-2 rounded-lg mb-2 text-sm">
        <span className="truncate">{file.name}</span>
        <button type="button" onClick={onClearFile} className="text-error text-xs font-medium">
          Remove
        </button>
      </div>
    )}
    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={() => fileInputRef.current?.click()}
        disabled={chatDisabled}
        className="text-on-surface-variant hover:text-primary disabled:opacity-40 p-2 rounded-full min-h-[44px] min-w-[44px] flex items-center justify-center"
        aria-label="Attach file"
      >
        <FaPaperclip size={18} />
      </button>
      <input
        ref={fileInputRef}
        type="file"
        className="hidden"
        onChange={(e) => e.target.files?.[0] && onFileSelect(e.target.files[0])}
      />
      <div className="flex-1 min-w-0">
        <input
          type="text"
          value={newMessage}
          onChange={(e) => onMessageChange(e.target.value.slice(0, remarksMax))}
          onKeyDown={onKeyDown}
          placeholder="Type a message..."
          disabled={chatDisabled}
          maxLength={remarksMax}
          className="w-full px-4 py-2.5 border border-surface-container rounded-full text-sm bg-surface-low disabled:opacity-50 focus:outline-none focus:ring-2 focus:ring-primary/30"
        />
        {showCharCount && (
          <p className="text-[10px] text-on-surface-variant text-right mt-0.5 pr-2">
            {newMessage.length}/{remarksMax}
          </p>
        )}
      </div>
      <button
        type="button"
        onClick={onSend}
        disabled={chatDisabled || (!newMessage.trim() && !file)}
        className="w-11 h-11 rounded-full bg-[#0B6B53] text-white flex items-center justify-center disabled:opacity-50 shrink-0 hover:opacity-90 transition-opacity"
        aria-label="Send message"
      >
        <FaPaperPlane size={14} />
      </button>
    </div>
  </div>
);

export default ChatInputBar;
